import {
  Colors,
  COLOR_BLACK,
  COLOR_WHITE,
  COLOR_SLATE,
  COLOR_LIGHT_SLATE,
  COLOR_LIME,
  COLOR_LIGHT_LIME,
  COLOR_ERROR,
  COLOR_OUTERSPACE,
  COLOR_SIDECAR,
  COLOR_SIDECAR_LIGHTER,
  COLOR_SIDECAR_DARK,
  COLOR_NEUTRAL_LIGHT,
  COLOR_NEUTRAL_LIGHTER,
  COLOR_NEUTRAL_LIGHTEST,
  COLOR_NEUTRAL_DARK,
  COLOR_NEUTRAL_DARKER,
  COLOR_NEUTRAL_DARKEST,
  COLOR_EARLS_GREEN,
  COLOR_EARLS_GREEN_DARK,
  COLOR_EARLS_GREEN_LIGHT,
  COLOR_EARLS_GREEN_LIGHTER,
  COLOR_EARLS_GREEN_LIGHTEST
} from '@src/types/colors';

export const getColorClasses = (
  color: Colors,
  styles: any
): { [x: number]: boolean } => ({
  [styles.colorBlack]: color === COLOR_BLACK,
  [styles.colorWhite]: color === COLOR_WHITE,
  [styles.colorSlate]: color === COLOR_SLATE,
  [styles.colorLightSlate]: color === COLOR_LIGHT_SLATE,
  [styles.colorLime]: color === COLOR_LIME,
  [styles.colorLightLime]: color === COLOR_LIGHT_LIME,
  [styles.colorError]: color === COLOR_ERROR,
  [styles.colorOuterspace]: color === COLOR_OUTERSPACE,
  [styles.colorSidecarDark]: color === COLOR_SIDECAR_DARK,
  [styles.colorSidecar]: color === COLOR_SIDECAR,
  [styles.colorSidecarLighter]: color === COLOR_SIDECAR_LIGHTER,
  [styles.colorNeutralLight]: color === COLOR_NEUTRAL_LIGHT,
  [styles.colorNeutralLighter]: color === COLOR_NEUTRAL_LIGHTER,
  [styles.colorNeutralLightest]: color === COLOR_NEUTRAL_LIGHTEST,
  [styles.colorNeutralDark]: color === COLOR_NEUTRAL_DARK,
  [styles.colorNeutralDarker]: color === COLOR_NEUTRAL_DARKER,
  [styles.colorNeutralDarkest]: color === COLOR_NEUTRAL_DARKEST,
  [styles.colorEarlsGreen]: color === COLOR_EARLS_GREEN,
  [styles.colorEarlsGreenLight]: color === COLOR_EARLS_GREEN_LIGHT,
  [styles.colorEarlsGreenLighter]: color === COLOR_EARLS_GREEN_LIGHTER,
  [styles.colorEarlsGreenLightest]: color === COLOR_EARLS_GREEN_LIGHTEST,
  [styles.colorEarlsGreenDark]: color === COLOR_EARLS_GREEN_DARK
});
